export default __webpack_public_path__ + "maps-examples-inset-map-thumbnail-480-aa7dcb6c7bf20e5fcf3beb2705358fbf.png";